export async function getAdress(ip = '8.8.8.8') {
    const response = await fetch(
        `https://geo.ipify.org/api/v2/country,city?apiKey=at_ZE1PxQ4YkfgLsuMsAGqmu2VIWGCL1&ipAddress=${ip}`
    );
    return await response.json();

    // .then((data) => setInfo(data)); // .then(setInfo)
}
